import { jsxs as f, jsx as o, Fragment as x } from "react/jsx-runtime";
import { f as $, n as h, m as y } from "../../vendor--aJiswR_.js";
import { forwardRef as B } from "react";
import { stupidInvertClasses as W } from "../../utils/index.js";
import { getButtonStyles as N } from "../BaseButton/index.js";
import { BaseIcon as n } from "../BaseIcon/index.js";
import { isIconName as a } from "../BaseIcon/typeGuards.js";
import { DotProgress as P } from "../DotProgress/index.js";
import { withTooltip as j } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as u } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index14.css';const w = "_button_1v4v4_1", R = "_fullWidth_1v4v4_9", S = "_sm_1v4v4_14", A = "_md_1v4v4_18", c = {
  button: w,
  fullWidth: R,
  sm: S,
  md: A
}, J = j(
  B(
    ({
      isPendingAriaLabel: v = "Loading",
      size: t = "md",
      fullWidth: p = !1,
      variant: _,
      href: s,
      startIcon: r,
      endIcon: i,
      children: d,
      __inverted: b,
      type: g = "button",
      ...m
    }, e) => {
      const l = $(
        N({
          variant: _ ?? (s ? "secondary" : "primary"),
          size: t,
          ...m
        }),
        c.button,
        c[t],
        p ? c.fullWidth : void 0,
        b ? W() : void 0
      );
      return typeof s == "string" ? /* @__PURE__ */ f(
        h,
        {
          ...u(m),
          href: s,
          className: l,
          "data-component": "Button",
          ref: e,
          children: [
            a(r) && /* @__PURE__ */ o(n, { icon: r, size: t }),
            d,
            a(i) && /* @__PURE__ */ o(n, { icon: i, size: t })
          ]
        }
      ) : /* @__PURE__ */ o(
        y,
        {
          ...u(m),
          type: g,
          "data-active": m.isActive ? "true" : void 0,
          className: l,
          "data-component": "Button",
          ref: e,
          children: m.isPending ? /* @__PURE__ */ o(P, { "aria-label": v, size: t }) : /* @__PURE__ */ f(x, { children: [
            a(r) && /* @__PURE__ */ o(n, { icon: r, size: t }),
            d,
            a(i) && /* @__PURE__ */ o(n, { icon: i, size: t })
          ] })
        }
      );
    }
  )
);
export {
  J as Button
};
//# sourceMappingURL=index.js.map
